window.onload = () => {
  if (document.querySelectorAll('.social-embed').length > 0) {
    document.querySelectorAll('.social-embed').forEach((embed) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('social-embed-wrapper');

      embed.parentNode.insertBefore(wrapper, embed);
      wrapper.appendChild(embed);

      if (embed.src.includes('tiktok.com')) {
        const url = new URL(embed.src);
        url.searchParams.set('autoplay', '0');
        embed.src = url.toString();
      }

      const setIframeHeight = (event) => {
        if (event.origin.includes('instagram.com') && event.source === embed.contentWindow) {
          try {
            const data = JSON.parse(event.data);
            if (typeof data === 'object' && data.type === 'MEASURE') {
              const { height } = data.details;
              wrapper.style.setProperty('--iframe-height', `${height}px`);
            }
          } catch (e) {
            console.error('Błąd parsowania danych Instagram:', e);
          }
        }
      
        if (event.origin.includes('tiktok.com') && event.source === embed.contentWindow) {
          try {
            if (event.data && event.data.startsWith('{')) {
              const data = JSON.parse(event.data);
              if (data && data.height) {
                const { height } = data;
                wrapper.style.setProperty('--iframe-height', `${height}px`);
              }
            } else {
              console.log('Received non-JSON message from TikTok:', event.data);
            }
          } catch (e) {
            console.error('Błąd parsowania danych TikTok:', e);
          }
        }
      };      

      window.addEventListener('message', setIframeHeight);

      setTimeout(() => {
        if (!wrapper.style.getPropertyValue('--iframe-height')) {
          wrapper.style.setProperty('--iframe-height', '800px');
          wrapper.classList.add('social-embed--default-height');
          embed.classList.add('social-embed--default-height');
          embed.setAttribute('scrolling', 'yes');
        }
      }, 1000);

      if (embed.classList.contains('expanded')) {
        embed.classList.remove('expanded');
        wrapper.classList.remove('expanded');
      } else {
        wrapper.classList.add('expanded');
        embed.classList.add('expanded');
      }
    });
  }
};
